import axios from 'axios';

interface CryptoIconData {
  symbol: string;
  name: string;
  image_path: string;
}

class CryptoIconsService {
  private static instance: CryptoIconsService;
  private iconsData: { [key: string]: CryptoIconData } | null = null;
  private isLoading = false;
  private loadPromise: Promise<void> | null = null;

  private constructor() {}

  static getInstance(): CryptoIconsService {
    if (!CryptoIconsService.instance) {
      CryptoIconsService.instance = new CryptoIconsService();
    }
    return CryptoIconsService.instance;
  }

  private async loadIconsData(): Promise<void> {
    if (this.iconsData) return;
    if (this.loadPromise) return this.loadPromise;

    this.loadPromise = (async () => {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        console.log('Chargement des données d\'icônes...');
        const response = await axios.get('https://cdn.cryptonvx.com/icons-data/index.json');
        this.iconsData = response.data;
        console.log('Données d\'icônes chargées:', Object.keys(this.iconsData || {}).length, 'symbols');
      } catch (error) {
        console.error('Erreur lors du chargement des icônes:', error);
        this.iconsData = null;
      } finally {
        this.isLoading = false;
        this.loadPromise = null;
      }
    })();

    return this.loadPromise;
  }

  async getCryptoIconUrl(symbol: string): Promise<string> {
    await this.loadIconsData();
    
    if (!this.iconsData) {
      console.warn('Aucune donnée d\'icônes disponible pour', symbol);
      return '';
    }

    const symbolUpper = symbol.toUpperCase();
    const data = this.iconsData[symbolUpper];
    
    if (data && data.image_path) {
      const url = `https://cdn.cryptonvx.com/icons-data/${data.image_path}`;
      console.log('URL d\'icône trouvée pour', symbol, ':', url);
      return url;
    }

    console.warn('Aucune icône trouvée pour', symbol);
    return '';
  }
}

export const cryptoIconsService = CryptoIconsService.getInstance(); 